export default "<button type=\"button\" [class]=\"finalClassList\">\r\n  <ng-content></ng-content>\r\n</button>\r\n"